"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Markdown = _interopRequireDefault(require("../text/Markdown"));

//
//  src/StringOrRender.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 7/24/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//
// eslint-disable-next-line @typescript-eslint/no-unused-vars

/* Lego Components */
var _default = function _default(props) {
  var value = props.value;

  if (!value) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, typeof value === "function" ? value() : /*#__PURE__*/_react["default"].createElement(_Markdown["default"], {
    text: value
  }));
};

exports["default"] = _default;